import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const ProductTableContainer = Loadable({
    loader: () => import('../../Containers/Product/ProductTableContainer'),
    loading: Loading,
});
const CreateProductContainer = Loadable({
    loader: () => import('../../Containers/Product/CreateProductContainer'),
    loading: Loading,
});
const EditProductContainer = Loadable({
    loader: () => import('../../Containers/Product/EditProductContainer'),
    loading: Loading,
});

const productRoutes = [
    { path: '/product/list', exact: true, name: 'Productos', component: ProductTableContainer },
    { path: '/product/create', exact: true, name: 'Nuevo Producto', component: CreateProductContainer },
    { path: '/product/:id/edit', exact: true, name: 'Modificar Producto', component: EditProductContainer },
];

export default productRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/product.js